import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UserRoleType } from '@vi-iot/client';

import { AuthStore } from '@store';

@Directive({
  selector: '[appShowForRsaRoles]',
})
export class ShowForRsaRolesDirective implements OnDestroy {
  private readonly allRoles = [
    UserRoleType.admin,
    UserRoleType.supportInternational,
    UserRoleType.supportInternationalWithRemoteDiagnosis,
    UserRoleType.supportLocalReadWrite,
    UserRoleType.supportLocalReadWriteWithRemoteDiagnosis,
    UserRoleType.supportLocalDepartmentManagement,
    UserRoleType.supportLocalReadOnly,
  ];
  private isAuthorized: boolean;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authStore: AuthStore
  ) {}

  @Input('appShowForRsaRoles') set showForRsaRole(roles: string[]) {
    this.authStore
      .isRsaUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isRsaUser) => {
        if (!isRsaUser) {
          return;
        }
        this.checkUserRole(roles);
        this.updateView();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private checkUserRole(roles: string[]): void {
    if (!roles) {
      this.viewContainer.clear();

      return;
    }

    if (!roles.some((role) => this.allRoles.includes(role as UserRoleType))) {
      this.viewContainer.clear();

      return;
    }

    this.authStore
      .getUserIotRole()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userIotRole) => {
        this.isAuthorized = userIotRole && roles.indexOf(userIotRole) >= 0;
      });
  }

  private updateView(): void {
    if (this.isAuthorized) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
